import http from './api'
import { ChessRoomSettings } from '../types/chess'

class ChessRoomSettingsService {
  async create(data: ChessRoomSettings): Promise<ChessRoomSettings> {
    const response = await http.post(`/chess-room-settings/${data.roomId}`, {
      winPoints: String(data.winPoints),
      drawPoints: String(data.drawPoints),
      losePoints: String(data.losePoints),
      tournamentType: data.tournamentType || 'none',
    })
    return response.data
  }

  async getByRoomId(roomId: string): Promise<ChessRoomSettings> {
    const response = await http.get(`/chess-room-settings/${roomId}`)
    return response.data
  }

  async update(roomId: string, data: Partial<ChessRoomSettings>): Promise<ChessRoomSettings> {
    const response = await http.post(`/chess-room-settings/${roomId}`, {
      winPoints: String(data.winPoints || 1),
      drawPoints: String(data.drawPoints || 0.5),
      losePoints: String(data.losePoints || 0),
      // Note: tournamentType is locked after creation, so we don't update it
    })
    return response.data
  }

  async delete(roomId: string): Promise<void> {
    // Note: Delete endpoint may not exist in backend, this is a placeholder
    await http.delete(`/chess-room-settings/${roomId}`)
  }
}

const chessRoomSettingsService = new ChessRoomSettingsService()
export default chessRoomSettingsService

